import React from "react";

export default function Customerbanner() {
  return (
    <div>
      <img
        src="https://d2638j3z8ek976.cloudfront.net/273734fd1adc77d549a5c41968668d77821e2194/1702557114/images/buying-online/background2.jpg"
        alt="customerinfo"
        width="100%"
        height="250px"
        style={{objectFit:"cover",backgroundPosition:'center',backgroundRepeat:'no-repeat'}}
      ></img>
    </div>
  );
}
